export const SAVE_PROSPECTOS: string = 'SAVE_PROSPECTOS'
export const STORE_PROCEDURE: string = 'STORE_PROCEDURE'
export const SAVE_TRAMITES: string = 'SAVE_TRAMITES'
export const COMPLETE_INPUT: string = 'COMPLETE_INPUT'
export const NEW_PROSPECTO_COMPLETED: string = 'NEW_PROSPECTO_COMPLETED'
export const CHANGE_EMAIL_CONTACT: string = 'CHANGE_EMAIL_CONTACT'
export const SAVE_PHOTO_FRONT: string = 'SAVE_PHOTO_FRONT'
export const SAVE_PHOTO_BACK: string = 'SAVE_PHOTO_BACK'
export const SAVE_PHOTO: string = 'SAVE_PHOTO'
export const SAVE_SCANNED_DOCUMENT: string = 'SAVE_SCANNED_DOCUMENT'
export const SAVE_CLIENT_PIN: string = 'SAVE_CLIENT_PIN'
export const SAVE_CLIENT_SIGN: string = 'SAVE_CLIENT_SIGN'
export const SAVE_PORTABILIDAD_ID: string = 'SAVE_PORTABILIDAD_ID'
export const SAVE_LINE_VALIDATION_RESPONSE: string = 'SAVE_LINE_VALIDATION_RESPONSE'
export const SAVE_IMG_RECOGNITION_RESPONSE: string = 'SAVE_IMG_RECOGNITION_RESPONSE'
export const SET_VALIDATION_TYPE: string = 'SET_VALIDATION_TYPE'
export const SAVE_SCANNED_CI: string = 'SAVE_SCANNED_CI'
export const SAVE_DOCUMENT_ID: string = 'SAVE_DOCUMENT_ID'
export const SAVE_LINE_NUMBER: string = 'SAVE_LINE_NUMBER'
export const PROCEDURE_COMPLETED: string = 'PROCEDURE_COMPLETED'
export const COMPLETE_DOCUMENT: string = 'COMPLETE_DOCUMENT'
export const CLEAR_LECTURE: string = 'CLEAR_LECTURE'
export const NEW_PROCEDURE_DATE: string = 'NEW_PROCEDURE_DATE'
export const CLEAR_SEARCH: string = 'CLEAR_SEARCH'
export const OBD_RESPONSE: string = 'OBD_RESPONSE'
export const SIM_DATA: string = 'SIM_DATA'

type axiosData = [] | {}

export const saveProspectos = (data: axiosData) => {
  return {
    type: SAVE_PROSPECTOS,
    payload: data
  }
}

export const storeProcedureDetail = (data: any) => {
  return {
    type: STORE_PROCEDURE,
    payload: data
  }
}

export const saveTramites = (data: axiosData) => {
  return {
    type: SAVE_TRAMITES,
    payload: data
  }
}

export const newProspectoCompleted = () => {
  return {
    type: NEW_PROSPECTO_COMPLETED
  }
}

export const procedureComplete = () => {
  return {
    type: PROCEDURE_COMPLETED
  }
}

export const changeEmailContact = (payload: any) => {
  return {
    type: CHANGE_EMAIL_CONTACT,
    payload
  }
}

export const saveScannedDocument = (payload: any) => {
  return {
    type: SAVE_SCANNED_DOCUMENT,
    payload
  }
}

export const saveClientPin = (payload: any) => {
  return {
    type: SAVE_CLIENT_PIN,
    payload
  }
}

export const saveClientSign = (payload: any) => {
  return {
    type: SAVE_CLIENT_SIGN,
    payload
  }
}

export const savePortabilidadId = (payload: any) => {
  return {
    type: SAVE_PORTABILIDAD_ID,
    payload
  }
}

export const saveLineValidationResponse = (payload: any) => {
  return {
    type: SAVE_LINE_VALIDATION_RESPONSE,
    payload
  }
}

export const saveImgRecognitionResponse = (payload: any) => {
  return {
    type: SAVE_IMG_RECOGNITION_RESPONSE,
    payload
  }
}

export const setValidationType = (payload: any) => {
  return {
    type: SET_VALIDATION_TYPE,
    payload
  }
}

export const saveScannedCI = (payload: any) => {
  return {
    type: SAVE_SCANNED_CI,
    payload
  }
}

export const saveDocumentId = (payload: any) => {
  return {
    type: SAVE_DOCUMENT_ID,
    payload
  }
}

export const saveLineNumber = (payload: any) => {
  return {
    type: SAVE_LINE_NUMBER,
    payload
  }
}

export const completeDocument = (payload: any) => {
  return {
    type: COMPLETE_DOCUMENT,
    payload
  }
}

export const obdResponse = (payload: any) => {
  return {
    type: OBD_RESPONSE,
    payload
  }
}

export const simDataStore = (payload: any) => {
  return {
    type: SIM_DATA,
    payload
  }
}

export const clearLecture = () => {
  return {
    type: CLEAR_LECTURE
  }
}

export const newProcedureDate = (date?: string) => {
  return {
    type: NEW_PROCEDURE_DATE,
    payload: date ?? ''
  }
}
